var _defs, _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 256,
    height: 256,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 32,
    y1: 115,
    x2: 224,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0825876,
    stopColor: "#FF5353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913745,
    stopColor: "#00AFFE"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 244,
    height: 244,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 52.4924V187.508L128 207.508L208 187.508V52.4924L133.821 71.0372C129.999 71.9927 126.001 71.9927 122.179 71.0372L48 52.4924ZM41.9403 34.4851C36.8911 33.2228 32 37.0417 32 42.2462V193.754C32 197.425 34.4984 200.625 38.0597 201.515L126.06 223.515C127.334 223.833 128.666 223.833 129.94 223.515L217.94 201.515C221.502 200.625 224 197.425 224 193.754V42.2462C224 37.0417 219.109 33.2228 214.06 34.4851L129.94 55.5149C128.666 55.8334 127.334 55.8334 126.06 55.5149L41.9403 34.4851Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78.7762C64 76.8453 65.7975 75.4173 67.6784 75.8539L117.678 87.4611C119.038 87.7766 120 88.9878 120 90.3833V100.224C120 102.155 118.202 103.583 116.322 103.146L66.3216 91.5389C64.9623 91.2234 64 90.0122 64 88.6167V78.7762Z",
    fill: "#3F51B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107.776C64 105.845 65.7975 104.417 67.6784 104.854L117.678 116.461C119.038 116.777 120 117.988 120 119.383V129.224C120 131.155 118.202 132.583 116.322 132.146L66.3216 120.539C64.9623 120.223 64 119.012 64 117.617V107.776Z",
    fill: "#3F51B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.efea0f2a094f69f60416e8d7f64b97a9.svg";
export { ForwardRef as ReactComponent };